var _excluded = ["className", "color"];
function cov_1wtc29amfz() {
  var path = "/app/src/components/logo/logo.tsx";
  var hash = "05bc45505e57e4168930c81530ce3b44f598803f";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/app/src/components/logo/logo.tsx",
    statementMap: {
      "0": {
        start: {
          line: 19,
          column: 20
        },
        end: {
          line: 66,
          column: 1
        }
      },
      "1": {
        start: {
          line: 24,
          column: 18
        },
        end: {
          line: 24,
          column: 53
        }
      },
      "2": {
        start: {
          line: 26,
          column: 27
        },
        end: {
          line: 59,
          column: 3
        }
      },
      "3": {
        start: {
          line: 27,
          column: 4
        },
        end: {
          line: 58,
          column: 5
        }
      },
      "4": {
        start: {
          line: 29,
          column: 8
        },
        end: {
          line: 29,
          column: 69
        }
      },
      "5": {
        start: {
          line: 31,
          column: 8
        },
        end: {
          line: 31,
          column: 74
        }
      },
      "6": {
        start: {
          line: 33,
          column: 8
        },
        end: {
          line: 33,
          column: 75
        }
      },
      "7": {
        start: {
          line: 35,
          column: 8
        },
        end: {
          line: 35,
          column: 69
        }
      },
      "8": {
        start: {
          line: 37,
          column: 8
        },
        end: {
          line: 37,
          column: 69
        }
      },
      "9": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 45,
          column: 10
        }
      },
      "10": {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 76
        }
      },
      "11": {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 54,
          column: 10
        }
      },
      "12": {
        start: {
          line: 57,
          column: 8
        },
        end: {
          line: 57,
          column: 43
        }
      },
      "13": {
        start: {
          line: 61,
          column: 2
        },
        end: {
          line: 65,
          column: 4
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 21
          }
        },
        loc: {
          start: {
            line: 23,
            column: 17
          },
          end: {
            line: 66,
            column: 1
          }
        },
        line: 23
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 26,
            column: 27
          },
          end: {
            line: 26,
            column: 28
          }
        },
        loc: {
          start: {
            line: 26,
            column: 33
          },
          end: {
            line: 59,
            column: 3
          }
        },
        line: 26
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 2
          },
          end: {
            line: 21,
            column: 26
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 21,
            column: 10
          },
          end: {
            line: 21,
            column: 26
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 27,
            column: 4
          },
          end: {
            line: 58,
            column: 5
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 28,
            column: 6
          },
          end: {
            line: 29,
            column: 69
          }
        }, {
          start: {
            line: 30,
            column: 6
          },
          end: {
            line: 31,
            column: 74
          }
        }, {
          start: {
            line: 32,
            column: 6
          },
          end: {
            line: 33,
            column: 75
          }
        }, {
          start: {
            line: 34,
            column: 6
          },
          end: {
            line: 35,
            column: 69
          }
        }, {
          start: {
            line: 36,
            column: 6
          },
          end: {
            line: 37,
            column: 69
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 45,
            column: 10
          }
        }, {
          start: {
            line: 46,
            column: 6
          },
          end: {
            line: 47,
            column: 76
          }
        }, {
          start: {
            line: 48,
            column: 6
          },
          end: {
            line: 54,
            column: 10
          }
        }, {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 57,
            column: 43
          }
        }],
        line: 27
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "05bc45505e57e4168930c81530ce3b44f598803f"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_1wtc29amfz = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_1wtc29amfz();
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import cn from 'classnames';
import React from 'react';
import { Icon } from 'src/components/icon';
import { ShadowView } from 'src/components/shadow-view';
import { ReactComponent as LogoEnWhiteOnTransparent } from './assets/logo-en-white-on-transparent.svg';
import { LogoEnBlackOnGreen } from './components/logo-en-black-on-green';
import { LogoEnBlackOnGreenAlshaya } from './components/logo-en-black-on-green-alshaya';
import { LogoEnBlackOnTransparent } from './components/logo-en-black-on-transparent';
import { LogoEnGrayOnTransparent } from './components/logo-en-gray-on-transparent';
import { LogoEnGreenOnBlack } from './components/logo-en-green-on-black';
import { LogoEnWhiteOnGreen } from './components/logo-en-white-on-green';
import styles from './styles.css';
/**
 * @link https://www.figma.com/file/uKBCGBTDE2yHJDFaB2I0k8/Branding?node-id=2%3A367
 */
cov_1wtc29amfz().s[0]++;
export var Logo = function Logo(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? (cov_1wtc29amfz().b[0][0]++, 'black on green') : _ref$color,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_1wtc29amfz().f[0]++;
  var classes = (cov_1wtc29amfz().s[1]++, cn(styles.tabbyInfoLogo, className));
  cov_1wtc29amfz().s[2]++;
  var getLogoComponent = function getLogoComponent() {
    cov_1wtc29amfz().f[1]++;
    cov_1wtc29amfz().s[3]++;
    switch (color) {
      case 'black on green':
        cov_1wtc29amfz().b[1][0]++;
        cov_1wtc29amfz().s[4]++;
        return /*#__PURE__*/React.createElement(LogoEnBlackOnGreen, _extends({}, props, {
          className: classes
        }));
      case 'gray on transparent':
        cov_1wtc29amfz().b[1][1]++;
        cov_1wtc29amfz().s[5]++;
        return /*#__PURE__*/React.createElement(LogoEnGrayOnTransparent, _extends({}, props, {
          className: classes
        }));
      case 'black on transparent':
        cov_1wtc29amfz().b[1][2]++;
        cov_1wtc29amfz().s[6]++;
        return /*#__PURE__*/React.createElement(LogoEnBlackOnTransparent, _extends({}, props, {
          className: classes
        }));
      case 'green on black':
        cov_1wtc29amfz().b[1][3]++;
        cov_1wtc29amfz().s[7]++;
        return /*#__PURE__*/React.createElement(LogoEnGreenOnBlack, _extends({}, props, {
          className: classes
        }));
      case 'white on green':
        cov_1wtc29amfz().b[1][4]++;
        cov_1wtc29amfz().s[8]++;
        return /*#__PURE__*/React.createElement(LogoEnWhiteOnGreen, _extends({}, props, {
          className: classes
        }));
      case 'white on transparent':
        cov_1wtc29amfz().b[1][5]++;
        cov_1wtc29amfz().s[9]++;
        return /*#__PURE__*/React.createElement(LogoEnWhiteOnTransparent, _extends({
          className: classes,
          viewBox: "0 0 90 30"
        }, props));
      case 'black on green alshaya':
        cov_1wtc29amfz().b[1][6]++;
        cov_1wtc29amfz().s[10]++;
        return /*#__PURE__*/React.createElement(LogoEnBlackOnGreenAlshaya, _extends({}, props, {
          className: classes
        }));
      case 'ramadan':
        cov_1wtc29amfz().b[1][7]++;
        cov_1wtc29amfz().s[11]++;
        return /*#__PURE__*/React.createElement("div", {
          className: cn(styles.ramadan)
        }, /*#__PURE__*/React.createElement(LogoEnBlackOnGreen, _extends({}, props, {
          className: classes
        })), /*#__PURE__*/React.createElement(Icon, {
          name: "ramadan"
        }));
      default:
        cov_1wtc29amfz().b[1][8]++;
        cov_1wtc29amfz().s[12]++;
        throw new Error('Not implemented');
    }
  };
  cov_1wtc29amfz().s[13]++;
  return /*#__PURE__*/React.createElement(ShadowView, {
    shouldInheritColor: true,
    shouldInheritFontFamily: true
  }, getLogoComponent());
};